import { useCallback, useEffect, useState } from "react";
import { FeedbackForm, YStack } from "@medbillai/ui";
import { Flag } from "@medbillai/utils";
import { AdaptiveDialogSheet } from "../../../components/AdaptiveDialogSheet";
import { analyticsService } from "../../../lib/analytics";
import { useBoolVariation } from "../../../lib/flag";
import { useSignUpOnboardingStore } from "../../../lib/sign-up-onboarding/signUpOnboardingStore";
import { REFERRAL_SOURCE_OPTIONS } from "./ReferralSourceOptions";
export function ReferralModal() {
  const showModalFlag = useBoolVariation(Flag.SHOW_POST_ONBOARDING_REFERRAL_MODAL, false);
  const shouldShowReferralModal = useSignUpOnboardingStore(state => state.shouldShowReferralModal);
  const setShouldShowReferralModal = useSignUpOnboardingStore(state => state.setShouldShowReferralModal);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    // Show modal only if explicitly told to and feature flag is enabled
    if (shouldShowReferralModal && showModalFlag) {
      setShowModal(true);
    } else {
      setShowModal(false);
    }
  }, [shouldShowReferralModal, showModalFlag]);
  const handleSubmit = useCallback((selectedOptions: string[], moreDetailsText?: string) => {
    analyticsService.trackEvent("PostOnboardingReferralSource", {
      sources: selectedOptions,
      ...(moreDetailsText && {
        moreDetails: moreDetailsText
      })
    });
    setShowModal(false);
    setShouldShowReferralModal(false);
  }, [setShouldShowReferralModal]);
  const handleOpenChange = useCallback((open: boolean) => {
    if (!open) {
      setShowModal(false);
      setShouldShowReferralModal(false);
    }
  }, [setShouldShowReferralModal]);
  return <AdaptiveDialogSheet open={showModal} onOpenChange={handleOpenChange} title="How did you hear about Granted?" hideTitle snapPoints={[90]} snapPointsMode="percent" sheetProps={{
    modal: true
  }} dialogContentProps={{
    width: 562
  }} scrollViewProps={{
    contentContainerStyle: {
      flexGrow: 1
    }
  }} data-sentry-element="AdaptiveDialogSheet" data-sentry-component="ReferralModal" data-sentry-source-file="ReferralModal.tsx">
      <YStack flex={1} $platform-native={{
      paddingTop: "$6",
      paddingBottom: "$2"
    }} data-sentry-element="YStack" data-sentry-source-file="ReferralModal.tsx">
        <FeedbackForm title="How did you hear about Granted?" subtitle="We'd love to know how you discovered us. This helps us improve our reach." options={REFERRAL_SOURCE_OPTIONS} continueButtonText="Submit" loading={false} onContinue={handleSubmit} moreDetailsProps={{
        onSubmit: handleSubmit,
        triggerLabels: ["Other"],
        placeholder: "How did you hear about us? Any other details?"
      }} data-sentry-element="FeedbackForm" data-sentry-source-file="ReferralModal.tsx" />
      </YStack>
    </AdaptiveDialogSheet>;
}